
import React, { useEffect, useState } from 'react';
import "../CSS/style.css";
import { /*FaTools,*/FaUser,FaBuilding} from "react-icons/fa";
import { GiScrew} from "react-icons/gi";
//import imagen2 from "../Img/user.png";
//import imagen3 from "../Img/user1.png";
import { useNavigate } from 'react-router';
import { getRol } from '../Conexiones/Conexion';
import '../CSS/login.css';
import Logo from '../Img/New-Rosmo-White.png'
import { getApi } from '../Conexiones/Models';
import { errorMessage } from '../Utils/AlertMessage';

function Principal() {
    const [totalEmp, setTotalEmp] = useState(0)
    const [totalObras, setTotalObras] = useState(0)
    const [totalMat, setTotalMat] = useState(0)
    const [userRol, setUserRol] = useState(null)
    const navigate = useNavigate()
    
    useEffect( ()=>{
        setUserRol(getRol())
        const getTotales = async () =>{
            const endpoint = 'totales/';
            const res = await getApi(endpoint);
            if(res.status === 1){
                if(res.data.length !== undefined){
                    setTotalEmp(res.data[0].empleados);
                    setTotalObras(res.data[0].obras);
                    setTotalMat(res.data[0].materiales);
                }else{
                    errorMessage(res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }           
        }
        if(getRol()==='UR001'){
            getTotales()
        }
    }, [navigate])

    const linkempleados = () => {
        navigate('Catalogos/Empleados');
    }
    const linkmateriales = () => {
        navigate('Catalogos/Materiales');
    }

    const linkobra = () => {
        navigate('Catalogos/Obras');
    }
    
    return (
        <div style={{marginTop:"42px", overflowY:'hidden', height:'92vh'}}>
            {userRol === 'UR001' ?
                <div className="cardBox" >
                    <div className="cardd" onClick={linkempleados}>                    
                        <div>
                            <div className="numbers">{totalEmp}</div>
                            <div className="cardName"  >Empleados</div>
                        </div>
                        <div className="iconBx">
                            <FaUser/>
                        </div>
                    </div>
                    <div className="cardd" onClick={linkobra}>
                        <div>
                            <div className="numbers">{totalObras}</div>
                            <div className="cardName">Obras</div>
                        </div>
                        <div className="iconBx">
                        <FaBuilding/>
                        </div>
                    </div>
                    <div className="cardd" onClick={linkmateriales}>
                        <div>
                            <div className="numbers">{totalMat}</div>
                            <div className="cardName">Materiales</div>
                        </div>
                        <div className="iconBx">
                            <GiScrew/>
                        </div>
                    </div>
                </div>:<div style={{marginTop:'3%'}}></div>
            }
            {userRol === 'UR001' ?
                <div className="details "  >
                    <div style={{width:'100%', textAlign:'center', backgroundColor:'#fafafa', borderRadius:20, height:'60vh',justifyContent:'center',display:'flex'}}>
                        <img src={Logo} alt="" width={'35%'} style={{margin:'0 auto', justifySelf:'center' }}/>
                    </div>
                </div>:
                <div className="details "  >
                    <div style={{width:'100%', textAlign:'center', backgroundColor:'#fafafa', borderRadius:20, height:'83vh',justifyContent:'center',display:'flex'}}>
                        <img src={Logo} alt="" width={'35%'} style={{margin:'0 auto', justifySelf:'center' }}/>
                    </div>
                </div>
            }
        </div>
    );
}

export default Principal;